import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../../Components/Loader/Spinner";

const GOOGLE_CLIENT_ID =
  "374803501351-vu4gf1huvhm0pvpsm5skt81uilumdhct.apps.googleusercontent.com";

const GOOGLE_SCRIPT_ID = "google-identity-services";
const GOOGLE_CREDENTIAL_STORAGE_KEY = "googleLoginCredential";

function loadGoogleScript() {
  return new Promise((resolve, reject) => {
    if (window.google?.accounts?.id) {
      resolve();
      return;
    }

    const existingScript = document.getElementById(GOOGLE_SCRIPT_ID);
    if (existingScript) {
      existingScript.addEventListener("load", resolve, { once: true });
      existingScript.addEventListener("error", reject, { once: true });
      return;
    }

    const script = document.createElement("script");
    script.id = GOOGLE_SCRIPT_ID;
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

export { GOOGLE_CREDENTIAL_STORAGE_KEY };

export default function GoogleAuthButton() {
  const navigate = useNavigate();
  const [isDark, setIsDark] = useState(
    typeof document !== "undefined" &&
      document.documentElement.classList.contains("dark"),
  );
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const buttonRef = useRef(null);

  useEffect(() => {
    if (typeof document === "undefined") {
      return;
    }

    const html = document.documentElement;
    const observer = new MutationObserver(() => {
      setIsDark(html.classList.contains("dark"));
    });

    observer.observe(html, { attributes: true, attributeFilter: ["class"] });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    let isMounted = true;

    setLoading(true);
    setHasError(false);

    loadGoogleScript()
      .then(() => {
        if (!isMounted || !buttonRef.current) {
          return;
        }

        window.google.accounts.id.initialize({
          client_id: GOOGLE_CLIENT_ID,
          callback: (response) => {
            if (!response?.credential) {
              return;
            }

            sessionStorage.setItem(
              GOOGLE_CREDENTIAL_STORAGE_KEY,
              response.credential,
            );
            navigate("/?path=google", { replace: true });
          },
        });

        buttonRef.current.innerHTML = "";
        window.google.accounts.id.renderButton(buttonRef.current, {
          type: "icon",
          theme: isDark ? "filled_black" : "outline",
          size: "large",
          text: "continue_with",
          shape: "circle",
          logo_alignment: "center",
          width: "199",
          locale: "en",
        });
        setLoading(false);
      })
      .catch(() => {
        if (isMounted) {
          setLoading(false);
          setHasError(true);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [isDark, navigate]);

  return (
    <div className="w-full flex flex-col items-center gap-1">
      {loading && (
        <div className="size-10 rounded-full  text-zi-text-light dark:text-zi-text-dark flex items-center justify-center py-2 overflow-hidden">
          <Loader size={34} stroke={3} color="white" />
        </div>
      )}
      <div
        ref={buttonRef}
        style={{ direction: "ltr" }}
        className={`w-full flex justify-center [direction:ltr] [&_*]:!transition-none [&_*]:!animate-none ${loading ? "hidden" : ""}`}
      />
      {hasError && (
        <p className="w-full text-amber-400 text-sm font-extralight">
          ورود با گوگل در دسترس نیست. لطفاً دوباره تلاش کنید.
        </p>
      )}
    </div>
  );
}
